import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    showMenu: true, // 選單
    showComingModal: false, // 功能開放預告彈窗
    showLanguageModal: false, // 語言切換彈窗
    showIdleModal: false, // 閒置彈窗
    showUserModal: false, // user 資訊彈窗
    showNotifyModal: false, // user 通知彈窗
    isCategoryPath: false, // 判斷是否為分類列表路徑
    showLoginModal: false, // 登入註冊彈窗
    showHintModal: false, // 提示小彈窗
    showComment: false, // 手機版留言
    hintText: '', // 提示文字
    showLoginFailModal: false, // 黑名單登入失敗
    showDeleteAccountModal: false, // 刪除帳號
    showWheelDetail: false, // 上線活動說明
    showWheelMenu: false, // 上線活動選單
    showWheelRecords: false,
    wheelSpinning: false,
    showConfirmModal: 'done', // 封鎖、刪除貼文、留言 確認彈窗
    showMutedModal: false, // 禁言彈窗
    showFullImageModal: false, // 滿版圖片預覽彈窗
    showReportModal: false, // 檢舉彈窗
    showAppLinkModal: false, // app 下載彈窗
    showAdultConfirmModal: false,
};

export const popSlice = createSlice({
    name: 'pop',
    initialState,
    reducers: {
        setShowMenu: (state, actions) => {
            state.showMenu = actions.payload;
        },
        setShowComingModal: (state, actions) => {
            state.showComingModal = actions.payload;
        },
        setShowLanguageModal: (state, actions) => {
            state.showLanguageModal = actions.payload;
        },
        setShowIdleModal: (state, actions) => {
            state.showIdleModal = actions.payload;
        },
        setShowUserModal: (state, actions) => {
            state.showUserModal = actions.payload;
        },
        setShowNotifyModal: (state, actions) => {
            state.showNotifyModal = actions.payload;
        },
        setIsCategoryPath: (state, actions) => {
            state.isCategoryPath = actions.payload;
        },
        setShowLoginModal: (state, actions) => {
            state.showLoginModal = actions.payload;
        },
        setShowHintModal: (state, actions) => {
            state.showHintModal = actions.payload;
        },
        setHintText: (state, actions) => {
            state.hintText = actions.payload;
        },
        setShowMobileBottomMenu: (state, actions) => {
            state.showMobileBottomMenu = actions.payload;
        },
        setShowComment: (state, actions) => {
            state.showComment = actions.payload;
        },
        setShowLoginFailModal: (state, actions) => {
            state.showLoginFailModal = actions.payload;
        },
        setShowDeleteAccountModal: (state, actions) => {
            state.showDeleteAccountModal = actions.payload;
        },
        setShowWheelDetail: (state, actions) => {
            state.showWheelDetail = actions.payload;
        },
        setShowWheelMenu: (state, actions) => {
            state.showWheelMenu = actions.payload;
        },
        setShowWheelRecords: (state, actions) => {
            state.showWheelRecords = actions.payload;
        },
        setWheelSpinning: (state, actions) => {
            state.wheelSpinning = actions.payload;
        },
        setShowConfirmModal: (state, action) => {
            state.showConfirmModal = action.payload;
        },
        setShowMutedModal: (state, action) => {
            state.showMutedModal = action.payload;
        },
        setShowFullImageModal: (state, action) => {
            state.showFullImageModal = action.payload;
        },
        setShowReportModal: (state, action) => {
            state.showReportModal = action.payload;
        },
        setShowAppLinkModal: (state, action) => {
            state.showAppLinkModal = action.payload;
        },
        setShowAdultConfirmModal: (state, action) => {
            state.showAdultConfirmModal = action.payload;
        },
    },
});

export const popState = (state) => state.pop;

export const {
    setShowMenu,
    setShowComingModal,
    setShowLanguageModal,
    setShowIdleModal,
    setShowUserModal,
    setShowNotifyModal,
    setIsCategoryPath,
    setShowLoginModal,
    setShowHintModal,
    setHintText,
    setShowComment,
    setShowLoginFailModal,
    setShowDeleteAccountModal,
    setShowWheelDetail,
    setShowWheelMenu,
    setShowWheelRecords,
    setWheelSpinning,
    setShowConfirmModal,
    setShowMutedModal,
    setShowFullImageModal,
    setShowReportModal,
    setShowAppLinkModal,
    setShowAdultConfirmModal,
} = popSlice.actions;

export default popSlice.reducer;
